import { render, staticRenderFns } from "./UserCreateFormWizard.vue?vue&type=template&id=5a8aeab0&"
import script from "./UserCreateFormWizard.vue?vue&type=script&lang=ts&"
export * from "./UserCreateFormWizard.vue?vue&type=script&lang=ts&"
import style0 from "./UserCreateFormWizard.vue?vue&type=style&index=0&id=5a8aeab0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports